<template>
<div>
	<v-autocomplete
		:value="value"
		:rules="rules"
		@change="$emit('change', $event)"
		:items="items"
		:loading="loading"
		item-text="1"
		item-value="0"
		ref="patronId_field"
		clearable
		:search-input.sync="search"
		:readonly="readonly"
		auto-select-first
		:error-messages="errors"
		no-filter
		dense
		hide-no-data
		:placeholder="items.length ? 'Selectionner un patron' : 'Rechercher un Patron'"
		:hint="hint">
		<template v-slot:label>
			<span v-if="param">
				{{ param | maestroParamLabel }}
			</span>
		</template>
		<!-- <template v-slot:selection="data">
				<v-chip
					label small
					color="white color--text"
					class="ma-0 mr-2 font-weight-bold">
					#{{ data.item.id }}
				</v-chip>
				<span class="pr-2">
					{{ data.item.name }}
				</span>
		</template> -->
		<!-- <template v-slot:item="data">
			<v-list-tile-avatar>
				<v-chip
					label small
					color="white color--text"
					class="ma-0 font-weight-bold">
					#{{ data.item.uid }}
				</v-chip>
			</v-list-tile-avatar>
			<v-list-tile-content>
				<v-list-tile-title>
					{{ data.item.description }}
				</v-list-tile-title>
				<v-list-tile-sub-title class="font-italic caption">
					{{ data.item.tags }}
				</v-list-tile-sub-title>
			</v-list-tile-content>
		</template> -->
	</v-autocomplete>
	<div class="solution-infos" v-if="validation_infos.is_valid === false">
		<tree-view
			:data="validation_infos"
			:options="{ maxDepth: 0, rootObjectKey: 'Solutions' }" />
	</div>
</div>
</template>

<script>
import { debounce } from 'debounce'
export default {
	props: [ 'value', 'rules', 'param', 'hint', 'readonly' ],
	data () {
		return {
			items: [],
			uids: [],
			descriptions: [],
			search: null,
			loading: false,
			has_choices: false,
			validation_infos: {},
			errors: []
		}
	},
	watch: {
		search (val) {
			if (val &&
				this.descriptions.indexOf(val) === -1 &&
				this.param.choices.length === 0) {
				this.patronSearch(val)
			}
		},
		value (val) {
			if (val && this.uids.indexOf(val) === -1) {
				this.getPatron(val)
			}
		}
	},
	methods: {
		patronSearch: debounce(function (search) {
			if (!search) return
			if (search.length < 2) return
			if (this.loading) return
			this.getPatrons(search)
		}, 100),
		getPatrons (search) {
			if (this.has_choices) return
			this.loading = true
			this.$EsMaestro.patron_search(search)
				.then(patrons => {
					this.items = patrons.map(patron => [patron.uid, patron.description])
					this.uids = patrons.map(patron => patron.uid)
					this.descriptions = patrons.map(patron => patron.description)
					if (patrons.length === 1) {
						let value = patrons[0].uid
						if (search === value) {
							this.$emit('change', value)
						}
					}
				})
				.catch(err => { console.log(err) })
				.finally(() => { this.loading = false })
		},
		getPatron (id) {
			if (this.has_choices) return
			this.loading = true
			this.$EsMaestro.patron_read(id)
				.then(patrons => {
					this.items = patrons.map(patron => [patron.uid, patron.description])
					this.uids = patrons.map(patron => patron.uid)
					this.descriptions = patrons.map(patron => patron.description)
				})
				.catch(err => { console.log(err) })
				.finally(() => { this.loading = false })
		}
	},
	mounted () {
		if (this.param.choices.length > 0) {
			this.items = this.param.choices
			this.has_choices = true
		}
	}
}
</script>

<style lang="stylus" scoped>
.solution-infos
	color: var(--v-error-base)
	margin-top: 4px
	margin-bottom: 20px
	padding: 4px 10px
	outline: 1px solid var(--v-error-base)
	>>>.tree-view-item-key-with-chevron:before
		color: var(--v-error-base) !important
</style>



// WEBPACK FOOTER //
// src/components/field_patron_id.vue